import { type Item } from '@cheqroom/api';

export const getStatusColor = (item: Pick<Item, 'kind' | 'status'>, isUnavailable = false) => {
	if (isUnavailable) return 'text-red-500';

	switch (item.status) {
		case 'available':
			return 'text-green-500';
		case 'checkedout':
		case 'in_custody':
			return 'text-red-500';
		case 'await_checkout':
			return 'text-yellow-500';
		case 'expired':
			return 'text-gray-400';
	}
};
